import { Instance } from 'mobx-state-tree';
import { AcceptUserInviteResponseDtoModelBase } from './AcceptUserInviteResponseDtoModel.base';

/* The TypeScript type of an instance of AcceptUserInviteResponseDtoModel */
export interface AcceptUserInviteResponseDtoModelType extends Instance<typeof AcceptUserInviteResponseDtoModel.Type> {}

/* A graphql query fragment builders for AcceptUserInviteResponseDtoModel */
export { selectFromAcceptUserInviteResponseDto, acceptUserInviteResponseDtoModelPrimitives, AcceptUserInviteResponseDtoModelSelector } from './AcceptUserInviteResponseDtoModel.base';

/**
 * AcceptUserInviteResponseDtoModel
 */
export const AcceptUserInviteResponseDtoModel = AcceptUserInviteResponseDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
